module.exports = __webpack_public_path__ + "img/7.55cc2769.jpg";